import { useEffect, useRef } from 'react';
import { ExtractionSpecType } from '../../types';
import './styles.css';

type ExtractionImagePreviewPropsType = {
    extractionSpec: ExtractionSpecType;
};

function ExtractionImagePreview({ extractionSpec }: ExtractionImagePreviewPropsType) {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    useEffect(() => {
        if (!canvasRef.current) {
            return;
        }

        const canvas = canvasRef.current;
        const canvasContext = canvas.getContext('2d');

        if (!canvasContext) {
            return;
        }

        canvas.width = extractionSpec.widthPX;
        canvas.height = extractionSpec.heightPX;

        canvasContext.putImageData(extractionSpec.imageData, 0, 0);
    }, [extractionSpec]);

    return (
        <div className="extraction-preview">
            <canvas className="extraction-preview__image" ref={canvasRef}></canvas>
        </div>
    );
}

export default ExtractionImagePreview;
